import { VITE_API_ENDPOINT } from '@app/consts/env_consts';

const Endpoints = {
  COMMON: {
    BASIC_AUTH: 'common/basic-login',
    AZURE_BASIC_AUTH: 'common/auth/azure',
    API_ENDPOINT: VITE_API_ENDPOINT || 'https://10.243.170.97:9091',
  },
  TIMEOUT: 500000, // in milliseconds 5mins
};

export { Endpoints };
